// oxlint-disable-next-line no-restricted-imports
import { Divider as MantineDivider } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";

type DividerType = "primary" | "secondary";
type DividerOrientation = "horizontal" | "vertical";

const VARIANT_COLORS: Record<DividerType, string> = {
  primary: colors.border.tertiary,
  secondary: colors.border.quaternary,
};

type DividerProps = {
  type?: DividerType;
  orientation?: DividerOrientation;
  color?: string;
  style?: React.CSSProperties;
};

const Divider = ({ type = "primary", orientation = "horizontal", color, style }: DividerProps) => {
  return (
    <MantineDivider orientation={orientation} color={color ?? VARIANT_COLORS[type]} style={style} />
  );
};

export { Divider };
export type { DividerType };
